<template>
  <div class="static-page community-page">
    <HeaderClean :header="$t('community.title')" :subheader="$t('community.subtitle')"/>

    <v-container tag="section" class="padding-top-35">

      <section class="community-page-section-chips">
        <h3 class="text-center">{{ $t('community.chips_section_title') }}</h3>
        <div class="community-page-chips">
          <v-chip label color="accent" v-for="chip in $t('community.chips_section_chips')" :key="chip">
            <strong>{{ chip }}</strong>
          </v-chip>
        </div>
      </section>

      <section>
        <h3 class="text-center">{{ $t('community.ad_section_title') }}</h3>
        <!-- <div class="community-page-chips">
          <v-btn color="primary" @click="goToForm">{{ $t('community.ad_section_button') }}</v-btn>
        </div> -->
      </section>

      <v-row class="padding-tb-30" :class="{'justify-center': !user}">
        <template v-if="user">
          <v-col>
            <h2>{{ $t('community.intro_title_user') }}</h2>
            <vue-markdown :key="!!user">{{ $t('community.intro_text_user') }}</vue-markdown>

            <v-btn dark :to="{name: 'new_estate'}" class="add-estate">
              <span class="font-13">{{$t('main_header.add_property')}}</span>
              <spacer width="10px"/>
              <v-icon class="icon-sm">mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </template>
        <!-- <v-col v-else>
          <h2>{{ $t('community.intro_title') }}</h2>
          <vue-markdown :key="user">{{ $t('community.intro_text') }}</vue-markdown>
          <signup class="signup-container" ref="signupForm" id="signup_form"/>
        </v-col> -->
        <v-col cols=12 sm=7>
          <cld-video playsinline autoplay publicId="marketing_videos/community" width="100%" :controls="controls"/>
        </v-col>
      </v-row>

      <section class="community-page-section-worth">
        <h3 class="text-center padding-20">{{ $t('community.worth_section_title') }}</h3>
        <v-row>
          <v-col cols="6" sm="3" v-for="(card, i) in $t('community.worth_section_cards')" :key="i" class="text-center">
            <v-card>
              <v-card-text>
                <h5 class="font-13">{{ card.title }}</h5>
                {{ card.text }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </section>

      <section class="community-page-section-give">
        <h3 class="text-center padding-20">{{ $t('community.give_section_title') }}</h3>
        <v-card>
          <v-row class="padding-30">
            <v-col cols="6" sm="3" v-for="card in $t('community.give_section_cards')" :key="card.title" class="text-center">
              <v-card>
                <v-card-text>
                  <v-icon class="icon-3xl">{{ card.icon }}</v-icon>
                  <h5 class="font-15 margin-top-10">{{ card.title }}</h5>
                  {{ card.text }}
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters class="padding-30">
            <v-col>
              <h5 class="font-18 padding-bottom-10">{{ $t('community.give_section_subtitle') }}</h5>
              <vue-markdown>{{ $t('community.give_section_text') }}</vue-markdown>
            </v-col>
          </v-row>
          <v-row no-gutters class="padding-sides-30">
            <v-col class="text-center">
              <!-- <v-btn color="primary" @click="goToForm">{{ $t('community.ad_section_button') }}</v-btn> -->
              <QuickContact inline page="community">
                <template slot="hidden-fields">
                  <input type="hidden" name="subject" value="קהילה">
                  <input type="hidden" name="message" value="קהילה">
                </template>
                <template v-slot:content>
                  <div class="text-center font-18 font-600">
                    <vue-markdown>{{$t("quick_contact.by_phone")}}</vue-markdown>
                    {{ $t("common.or") }}
                    <a :href="'0774110137' | whatsapp($t('community.whatsapp_message'))" target="_blank">
                      {{ $t("quick_contact.or_whatsapp") }}
                      <v-icon class="icon-lg" color="var(--v-whatsapp)">mdi-whatsapp</v-icon>
                    </a>
                  </div>
                </template>
              </QuickContact>

            </v-col>
          </v-row>
          <spacer height="20px"/>
        </v-card>
      </section>

      <spacer height="20px"/>
      <!-- <v-divider/>
      <spacer height="20px"/> -->

      <!-- <v-expansion-panels multiple role="list">
        <v-expansion-panel class="v-expansion-panel--active" v-for="q in $t('community.questions')" :key="q.q" role="listitem">
          <v-expansion-panel-header class="font-18 font-600" role="term">
            {{q.q}}
          </v-expansion-panel-header>

          <v-expansion-panel-content role="definition">
            <vue-markdown>{{q.a}}</vue-markdown>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <spacer height="20px"/> -->

      <!-- magazine -->
      <!-- <v-row>
        <v-col cols=12 sm="4" v-for="art in articles" :key="art.id">
          <article-box :article="art" image-width="250" small/>
        </v-col>
      </v-row> -->
    </v-container>
  </div>
</template>

<script>
import HeaderClean from '@/app/common/components/header-clean'
// import ArticleBox from '@/app/modules/magazine/components/article-box'
// import MagazineService from '@/app/modules/magazine/magazine-service'
// import Signup from '@/app/modules/user/components/signup-form'
import { mapGetters } from 'vuex'
import VueScrollTo from 'vue-scrollto'
import QuickContact from '@/common/components/quick-contact'

export default {

  name: 'community',

  // TODO: meta

  components: {
    HeaderClean,
    QuickContact
    // ArticleBox,
    // Signup
  },

  data () {
    return {
      // articles: [],
      controls: true,
      chips: []
    }
  },

  computed: {
    ...mapGetters('user', ['user'])
  },

  methods: {
    goToForm () {
      this.$refs.signupForm.$refs.form.$el['firstName'].focus()
      VueScrollTo.scrollTo('#signup_form', { offset: -75 })
    }
    // downloadPdf () {
    //   return this.$cloudinary.url('pdfs/family-economy.pdf', { flags: 'attachment' })
    // }
  },

  async created () {
    // this.articles = await MagazineService.getArticles(1, 3)
    setTimeout(() => {
      this.controls = true
    }, 22000)
  }

  // mounted () {
  //   console.log(this.$refs.signupForm.$refs.form.$el['firstName'])
  // }
}
</script>

<style lang="scss" scoped>

  .community-page {

    video {
      min-height: min(100vh, 820px);
    }

    &-chips {
      display: flex;
      flex-flow: wrap;
      gap: 15px;
      justify-content: center;
      padding: 20px 0;
    }

    .signup-container {
      padding: 12px;
      border: 1px solid var(--v-bright-darken4);
      border-radius: 4px;
    }

      &-section-give,
      &-section-worth {

        .row {

          .v-card {
            min-height: 100%;
          }
        }
      }
  }
</style>
